import { CodeContainer, CodeLabel, ResendCode } from './InputCode.styles';
import React, { useEffect, useRef, useState } from 'react';

interface IInputCode {
	length: number;
	label: string;
	loading: boolean;
	error?: boolean;
	resendCodeVisible?: boolean;
	onResendCode?: () => void;
	onComplete: (value: string) => void;
}

export const InputCode = ({
	length,
	label,
	loading,
	error,
	resendCodeVisible,
	onResendCode,
	onComplete,
}: IInputCode) => {
	const [timerActive, setTimerActive] = useState(false);
	const timerRef = useRef<any>();
	const [time, setTime] = useState<number>(15);
	const [code, setCode] = useState([...Array(length)].map(() => ''));
	const inputs = useRef<(HTMLInputElement | null)[]>([]);

	const handleResendCode = () => {
		setTimerActive(true);
		onResendCode && onResendCode();
		timerRef.current = setInterval(() => {
			setTime((time) => time - 1);
		}, 1000);
	};

	useEffect(() => {
		if (time === 0) {
			clearInterval(timerRef.current);
			setTime(15);
			setTimerActive(false);
		}
	}, [time]);

	const processInput = (event: any, index: number) => {
		const num = event.target.value;
		const isNotNumber = /[^0-9]/.test(num);

		if (isNotNumber) return;

		if (num.length > 1) {
			const newCode = [...code];
			num.split('').forEach((n: any, i: number) => {
				newCode[index + i] = n;
			});
			setCode(newCode);
			inputs.current[num.length]?.focus();
			if (newCode.every((num: any) => num !== '')) {
				onComplete(newCode.join(''));
			}
			return;
		}

		const newCode = [...code];
		newCode[index] = num;
		setCode(newCode);
		if (index !== length - 1) {
			inputs.current[index + 1]?.focus();
		}
		if (newCode.every((num) => num !== '')) {
			onComplete(newCode.join(''));
		}
	};

	const onKeyUp = (event: any, index: number) => {
		if (event.keyCode === 8 && !code[index] && index !== 0) {
			const newCode = [...code];
			newCode[index - 1] = '';
			setCode(newCode);
			inputs.current[index - 1]?.focus();
		}
	};

	return (
		<React.Fragment>
			<div>
				<CodeLabel>{label}</CodeLabel>
				<CodeContainer error={error}>
					{code.map((num, index) => {
						return (
							<input
								key={index}
								id={`input-code-${index}`}
								type="text"
								inputMode="numeric"
								value={num}
								autoFocus={!code[0].length && index === 0}
								readOnly={loading}
								onChange={(event) => processInput(event, index)}
								onKeyUp={(event) => onKeyUp(event, index)}
								ref={(ref) => inputs.current.push(ref)}
							/>
						);
					})}
				</CodeContainer>
				{resendCodeVisible && (
					<ResendCode
						onClick={() => {
							!timerActive && handleResendCode();
						}}
					>
						{!timerActive
							? 'Reenviar código de nuevo'
							: `Reenviar código de nuevo en ${time}`}
					</ResendCode>
				)}
			</div>
		</React.Fragment>
	);
};
